import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { updateLocation } from "api";
//
import {
    makeStyles,
    Button,
    Checkbox,
    Grid,
    FormControlLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    dialog: {
        padding: theme.spacing(1),
        overflowY: "visible",
    },
    content: {
        overflowY: "visible",
    },
}));

const schema = yup
    .object({
        checkDailyHours: yup.boolean(),
        checkQuarterHours: yup.boolean(),
    })
    .required();

export default function CheckHoursDialog({ location, open, handleClose }) {
    const {
        handleSubmit,
        setValue,
        control,
        formState: { isSubmitting },
    } = useForm({
        defaultValues: {
            checkDailyHours: true,
            checkQuarterHours: true,
        },
        resolver: yupResolver(schema),
    });
    const classes = useStyles();

    useEffect(() => {
        if (location) {
            setValue("checkDailyHours", location.checkDailyHours);
            setValue("checkQuarterHours", location.checkQuarterHours);
        }
    }, [location, setValue]);

    const onSubmit = (data) => {
        updateLocation(location.id, {
            title: location.title,
            domain: location.domain,
            shortcut: location.shortcut,
            weekHours: location.weekHours,
            workingDays: location.workingDays,
            buttons: location.buttons,
            checkDailyHours: data.checkDailyHours,
            checkQuarterHours: data.checkQuarterHours,
        }).then(() => {
            handleSubmit();
            handleClose();
        });
    };

    return (
        <Dialog
            fullWidth
            maxWidth="xs"
            open={open}
            onClose={handleClose}
            PaperProps={{
                className: classes.dialog,
            }}
        >
            <DialogTitle>Checking hours - {location?.key}</DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogContent className={classes.content}>
                    <Grid container spacing={2} direction="column">
                        <Grid item>
                            <Controller
                                control={control}
                                name="checkDailyHours"
                                render={({ field: { onChange, value } }) => (
                                    <FormControlLabel
                                        label="Check daily hours"
                                        control={
                                            <Checkbox
                                                checked={value}
                                                onChange={onChange}
                                                id="checkDailyHours"
                                                color="primary"
                                            />
                                        }
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item>
                            <Controller
                                control={control}
                                name="checkQuarterHours"
                                render={({ field: { onChange, value } }) => (
                                    <FormControlLabel
                                        label="Check quarterly hours"
                                        control={
                                            <Checkbox
                                                checked={value}
                                                onChange={onChange}
                                                id="checkQuarterHours"
                                                color="primary"
                                            />
                                        }
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleClose}>
                        cancel
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isSubmitting}
                    >
                        submit
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
